// extracted by mini-css-extract-plugin
export var actionButton = "_5x-1";
export var actionButtons = "_5x-2";
export var actions = "_5x-0";
export var aiUnread = "_5x-10";
export var alignCenter = "_5x-h";
export var backWrapper = "_5x-3";
export var cellContainer = "_5x-4";
export var checkboxContainer = "_5x-5";
export var contentContainer = "_5x-6";
export var contentHeader = "_5x-8";
export var conversationsTableWrapper = "_5x-s";
export var draftReplyBadgeContainer = "_5x-m";
export var dropdownItem = "_5x-b";
export var dropdownItemsContainer = "_5x-a";
export var dropdownTitle = "_5x-c";
export var errorIcon = "_5x-7";
export var filter = "_5x-d";
export var gray = "_5x-i";
export var headerActionButtons = "_5x-e";
export var headerCheckboxContainer = "_5x-f";
export var icon = "_5x-j";
export var menuContainer = "_5x-k";
export var noMoreTicketsIcon = "_5x-12";
export var noMoreTicketsSubText = "_5x-13";
export var oneLine = "_5x-l";
export var optionsButton = "_5x-n";
export var plus = "_5x-o";
export var portalButtonsWrapper = "_5x-g";
export var red = "_5x-p";
export var scrolledTop = "_5x-9";
export var search = "_5x-q";
export var selectedConversationsCount = "_5x-r";
export var spinner = "_5x-t";
export var strong = "_5x-u";
export var summaryCell = "_5x-v";
export var tableContainer = "_5x-11";
export var tagContainer = "_5x-w";
export var threeDots = "_5x-x";
export var twoLines = "_5x-y";
export var unread = "_5x-z";